import {
  Radio,
  FormControlLabel,
  RadioGroup,
  Typography,
  Box,
} from "@mui/material";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function RoutsLists(props) {
  const { isSmall } = useBreakpoints();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflowY: "auto",
        height: "100%",
      }}
      gridColumn={isSmall ? "span 12" : "span 2"}
    >
      <Typography
        variant="subtitle1"
        sx={{
          textAlign: "center",
          width: "100%",
          p: 1,
          borderBottom: "1px solid #cdcdcd",
        }}
      >
        روت ها
      </Typography>
      <Box
        sx={{
          height: "100%",
          overflowY: "auto",
          width: "100%",
          px: 0.5,
          my: 1,
        }}
      >
        <RadioGroup
          defaultValue={""}
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={props.routSelect ?? " "}
          onChange={(event) => {
            props.setOneOrderSearch("");
            props.setroutSelect(event.target.value);
            props.setChangeCenter(true);
            props.setMapCenter([35.7009, 51.391241]);
            props.setOrderModel({
              ...props.orderModel,
              zoneIndex: event.target.value,
              orderID: undefined,
            });
            props.setAssignModel({
              ...props.assignModel,
              zoneIndex: event.target.value,
              orderID: undefined,
            });
            props.setOrders();
            let model = {
              deliveryDate: props.filters.deliveryDate,
              deliveryPart: props.filters.deliveryPart,
              zoneIndex: event.target.value,
            };
            props.setChangeZoom(true);
            props.callback(model);
          }}
        >
          {props.routes &&
            props.routes.map((m) => {
              return (
                <Box
                  key={m.id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    py: 0.5,
                    borderBottom: "1px solid #cdcdcd",
                  }}
                >
                  <span
                    style={{
                      marginLeft: "10px",
                      backgroundColor: m.color,
                      width: "1rem",
                      height: "1rem",
                      borderRadius: "3rem 3rem 0",
                      display: "block",
                      position: "relative",
                      transform: "rotate(45deg)",
                    }}
                  ></span>
                  <FormControlLabel
                    value={m.zoneIndex}
                    sx={{
                      "&.MuiFormControlLabel-root .MuiFormControlLabel-label ":
                        {
                          color: "secondary.main",
                        },
                    }}
                    control={<Radio size="small" color="secondary" />}
                    label={
                      <Typography variant="subtitle2">
                        {m.title} ({m.orders})
                      </Typography>
                    }
                  />
                </Box>
              );
            })}
        </RadioGroup>
      </Box>
    </Box>
  );
}
